import { render, staticRenderFns } from "./KendoGridComponent.vue?vue&type=template&id=70473beb&"
import script from "./KendoGridComponent.vue?vue&type=script&lang=js&"
export * from "./KendoGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./KendoGridComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports